import { useAuth } from "oidc-react";
import React from "react";
import { ReactElement, Suspense, useEffect, useState } from "react";
import {useLocation, useNavigate} from "react-router-dom";
import { ApplicationUserRole } from "../../api";
import {loadingSpin, RoutingPaths} from "./routingContainer";
import {useSelector} from "react-redux";
import {getCurrentUser} from "../../redux/applicationUserSlice";
import useCurrentUserRoles from "../../hooks/useCurrentUserRoles";

export function AuthInitialized(props: { children: ReactElement }) {
    const [ isTryingToLogin, setIsTryingToLogin ] = useState<boolean>(false);
    const auth = useAuth();

    useEffect(() => {
        if (!auth.isLoading && !auth.userData) {
            setIsTryingToLogin(true);

            auth.userManager.signinSilent().finally(() => setIsTryingToLogin(false));
        }
    }, [auth.isLoading, auth.userData, auth.userManager]);

    if (auth.isLoading) {
        return loadingSpin;
    }

    if (isTryingToLogin) {
        return loadingSpin;
    }

    return <Suspense fallback={loadingSpin}>
        {props.children}
    </Suspense>;
}

export function Protected(props: { children: ReactElement, allowedForRoles?: ApplicationUserRole[] }) {
    const auth = useAuth();
    const location = useLocation();
    const navigate = useNavigate();
    const roles = useCurrentUserRoles();
    const user = useSelector(getCurrentUser);

    useEffect(() => {
        if (props.allowedForRoles && user && !roles.some(r => props.allowedForRoles!.includes(r))) {
            navigate(RoutingPaths.mainPage.route, { replace: true });
        }
    }, [user, roles, props.allowedForRoles, navigate]);

    if (auth.isLoading) {
        return loadingSpin;
    }

    if (!auth.userData) {
        auth.userManager.signinSilent().catch(() => auth.signIn({ state: { targetPath: location.pathname } }));
        return loadingSpin;
    }

    return <Suspense fallback={loadingSpin}>
        {props.children}
    </Suspense>;
}
